export default {"src":"/_next/static/media/johnson_black.94c042ba.svg","height":55,"width":165,"blurWidth":0,"blurHeight":0};